<script lang="ts">
	import { createContact } from "../scripts/api/apiNewsletters";
    import { NEWSLETTER_CARTO, NEWSLETTER_PARTNER } from "../scripts/constant";
    import { redirectTo } from "../scripts/router1";
	import { idPageMentionsLegales } from "../scripts/router2";
	import { storeIsOpenNewsletterRegistration, storeNewsletterRegistrationTitle, storeNewsletterRegistrationText, storeNewsletterRegistrationImage } from "../scripts/store";
    import { addNotificationError } from "../scripts/toaster";

	let firstName: string = "";
	let lastName: string = "";
	let email: string = "";
	let ptce_o_n: string = "";
	let ptce_name: string = "";

	function registration() {
		if (lastName == "" || firstName == "" || email == "" || ptce_o_n == "") {
			addNotificationError("Merci de renseigner <br> tous les champs obligatoires (*)");
		} else {
			createContact(lastName, firstName, ptce_o_n, ptce_name, email);
			close();
		}
	}

	function close() {
		storeIsOpenNewsletterRegistration.set(false);
		email = "";
		firstName = "";
		lastName = "";
		ptce_o_n = "";
		ptce_name = "";
	}

	function goToMentions() {
		close();
		redirectTo(idPageMentionsLegales);
	}

	function ptceCheck(event) {
		ptce_o_n = event.currentTarget.value;
	}
</script>

<style lang="scss">

	.newsletterRegistration {
		display: none;
		&__open {
			display: block;
			z-index: 10000;
			position: fixed;
			top: -90px;
			left: 0px;
			width: 100%;
			height: 120%;
			background-color: $color_white;
			opacity: 0.9;
			margin: 30px 0;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			align-items: center;
			padding: 10px 10px 10px 10px;
			font-family: 'Borna-Medium';
			font-size: 16px;
		}
	}

	.ballLeft {
		display: none;
		&__open {
			display: block;
			position: fixed;
			width: 80%;
			height: 80%;
			opacity: 1;
			z-index: 10001;
		}
		&__ballPrimary {
			position: absolute;
			border-radius: 50%;
			height: 300px;
			width: 300px;
			background-color: $color_primary;
			bottom: -220px;
			left: -165px;
		}
	}

	.newsletterRegistrationInside {
		display: none;
		&__title {
			font-size: 16px;
			margin: -46px 30px 0 30px;
		}
		&__intro {
			font-size: 13px;
			margin-top: 40px;
			padding: 0 0 0 34px;
		}
		&__open {
			display: block;
			z-index: 10002;
			position: fixed;
			top: 30px;
			margin-left: auto;
			margin-right: auto;
			width: 80%;
			height: 80%;
			background-color: $color_grey;
			opacity: 1;
			margin: 30px 0;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: center;
			padding: 10px 10px 10px 10px;
			font-family: 'Borna-Medium';
			font-size: 16px;
			&__inputs {
				width: 100%;
				padding: 10px 0 10px 0;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				align-items: center;
			}
			&__input {
				all: unset;
				width: 100%;
				margin: 10px 0 10px 0;
				position: relative;
				border: 1px solid $color_black;
				background-color: $color_white;
				color: $color_black;
				font-family: 'Borna-Regular';
				font-size: 16px;
				padding: 10px 20px 10px 20px;
				&__grey {
					background-color: $color_grey;
				}
			}
			&__radio {
				margin: 0 3px 0 5px;
				position: relative;
				border: 1px solid $color_black;
				background-color: $color_white;
				color: $color_black;
				accent-color: $color_primary;
			}
			&__ballRight {
				position: absolute;
				border-radius: 50%;
				height: 50px;
				width: 50px;
				background-color: $color_secondary;
				top: 20%;
				right: -25px;
			}
			&__mailbox {
				display: none;
			}
			&__hommeMachine {
				display: none;
			}
			&__label {
				font-size: 14px;
				margin: 10px 0 10px 0;
				&__mobile {
					display: block;
				}
				&__desktop {
					display: none;
				}
			}
			&__asterix {
				font-size: 10px;
				text-decoration: underline;
			}
		}
	}

	.newsletterButton {
		width: 110%;
		margin: 0 0 30px 0;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		border: 1px solid $color_black;
		border-radius: 45px;
		background-color: $color_grey;
		padding: 10px 10px 10px 10px;
		font-family: 'Borna-Medium';
		font-size: 13px;
	}

	.newsexclamation {
		padding: 0 0 0 20px;
	}
	.newsbtn {
		cursor: pointer;
		border: 1px solid $color_black;
		height: 40px;
		border-radius: 40px;
		background-color: $color_white;
		display: flex;
		flex-direction: row;
		justify-content: space-around;
		align-items: center;
		padding: 5px 15px 5px 15px;
		margin: 10px 0 0 0;
		&__text {
			font-family: 'Borna-Medium';
			font-size: 16px;
			padding: 0 4px 0 0;
		}
		&__img {
			width: 8px;
			height: 8px;
		}
		&:hover {
			background-color: $color_primary;
		}
	}

	.twoInputs {
		width: 80%;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		&__space {
			display: none;
		}
		&__row {
			flex-direction: row;
			justify-content: flex-start;
			width: auto;
		}
	}

	@include large {

		.ballLeft {
			display: none;
			&__open {
				display: block;
				position: fixed;
				width: 80%;
				height: 80%;
				opacity: 1;
				z-index: 10001;
			}
			&__ballPrimary {
				position: absolute;
				border-radius: 50%;
				height: 300px;
				width: 300px;
				background-color: $color_primary;
				bottom: -5%;
				left: -2%;
			}
		}

		.newsletterRegistrationInside {
			display: none;
			&__title {
				font-size: 2vw;
			}
			&__intro {
				font-size: 1.5vw;
				width: 70%;
			}
			&__open {
				display: flex;
				width: 60%;
				height: auto;
				font-size: 1.2vw;
				margin: 200px 0 0 0;
				&__inputs {
					padding: 20px 0 20px 0;
				}
				&__input {
					font-size: 1.2vw;
					padding: 10px 20px 10px 20px;
					margin: 10px 0 10px 0;
				}
				&__radio {
					margin: 0 10px 0 10px;
				}
				&__ballRight {
					height: 100px;
					width: 100px;
					top: 20%;
					right: -50px;
				}
				&__mailbox {
					display: block;
					position: absolute;
					top: -200px;
					right: 100px;
					width: 90px;
					&__img {
						width: 100%;
						height: 100%;
					}
				}
				&__hommeMachine {
					display: block;
					position: absolute;
					top: -180px;
					right: 0px;
					width: 200px;
					&__img {
						width: 100%;
						height: 100%;
					}
				}
				&__fermiere {
					display: block;
					position: absolute;
					top: -180px;
					right: 0px;
					width: 260px;
					&__img {
						width: 100%;
						height: 100%;
					}
				}
				&__label {
					font-size: 1.2vw;
					margin: 10px 0 10px 0;
					&__mobile {
						display: none;
					}
					&__desktop {
						display: block;
					}
				}
				&__asterix {
					cursor: pointer;
					font-size: 1.2vw;
					text-decoration: underline;
				}
			}
		}

		.newsletterButton {
			margin: 40px 0 40px 0;
			border-radius: 40px;
			width: 70%;
			flex-direction: row;
			height: 40px;
			font-size: 1.2vw;
		}
		.newsbtn {
			margin: 0 0 30px 0;
			&__text {
				font-size: 1.2vw;
			}
		}

		.twoInputs {
			width: 80%;
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: center;
			&__space {
				display: block;
				min-width: 10px;
			}
			&__row {
				width: 80%;
				flex-direction: row;
				justify-content: flex-start;
			}
		}

	}

	@include xlarge {

		.newsletterRegistrationInside {
			&__title {
				font-size: 28px;
			}
			&__intro {
				font-size: 21px;
			}
			&__open {
				font-size: 16px;
				&__input {
					font-size: 16px;
				}
				&__label {
					font-size: 16px;
				}
				&__asterix {
					font-size: 16px;
				}
			}
		}

		.newsletterButton {
			font-size: 16px;
		}
		.newsbtn {
			&__text {
				font-size: 16px;
			}
		}
	}

</style>

<div class="newsletterRegistration" class:newsletterRegistration__open={$storeIsOpenNewsletterRegistration} on:click={close} on:keydown={close}>
</div>
<div class="ballLeft" class:ballLeft__open={$storeIsOpenNewsletterRegistration} on:click={close} on:keydown={close}>
	<div class="ballLeft__ballPrimary"></div>
</div>
<div class="newsletterRegistrationInside page__contener" class:newsletterRegistrationInside__open={$storeIsOpenNewsletterRegistration}>
	<div class="page__title newsletterRegistrationInside__title">{@html $storeNewsletterRegistrationTitle}</div>
	<div class="page__intro newsletterRegistrationInside__intro">{@html $storeNewsletterRegistrationText}</div>
	<div class="newsletterRegistrationInside__open__inputs">
		<div class="twoInputs">
			<input id="idLastName" class="newsletterRegistrationInside__open__input" type="text" bind:value={lastName} placeholder="Nom *">
			<div class="twoInputs__space"></div>
			<input id="idFirstName" class="newsletterRegistrationInside__open__input" type="text" bind:value={firstName} placeholder="Prénom *">	
		</div>
		<div class="twoInputs">
			<input id="idEmail" class="newsletterRegistrationInside__open__input" type="text" bind:value={email} placeholder="Adresse mail *">
		</div>
		<div class="twoInputs twoInputs__row">
			<div class="newsletterRegistrationInside__open__label newsletterRegistrationInside__open__label__mobile">Partie prenante d’un PTCE ? *</div>
			<div class="newsletterRegistrationInside__open__label newsletterRegistrationInside__open__label__desktop">Êtes-vous partie prenante d’un PTCE ? *</div>
			<input class="newsletterRegistrationInside__open__radio" type="radio" id="ptceo" name="ptceon" value="oui" checked={ptce_o_n==="oui"} on:change={ptceCheck}>
			<label for="ptceo" class="newsletterRegistrationInside__open__label">Oui</label>
			<input class="newsletterRegistrationInside__open__radio" type="radio" id="ptcen" name="ptceon" value="non" checked={ptce_o_n==="oui"} on:change={ptceCheck}>
			<label for="ptcen" class="newsletterRegistrationInside__open__label">Non</label>
		</div>
		<div class="twoInputs">
			<input id="isPtceName" class="newsletterRegistrationInside__open__input newsletterRegistrationInside__open__input__grey" type="text" bind:value={ptce_name} placeholder="Nom du PTCE">
		</div>
	</div>
		<div class="newsbtn" on:click={() => registration()} on:keydown={() => registration()}>
			<div class="newsbtn__text">je m'inscris à la newsletter</div>
			<img class="newsbtn__img" src="../assets/images/btn_recherche_fleche_seule.svg" alt="newsletter">
		</div>
	<div class="newsletterRegistrationInside__open__ballRight"></div>
	{#if ($storeNewsletterRegistrationImage == NEWSLETTER_CARTO)}
	<div class="newsletterRegistrationInside__open__hommeMachine">
		<img class="newsletterRegistrationInside__open__hommeMachine__img" src="../assets/images/homme_machine.png" alt="en construction">
	</div>
	{:else if ($storeNewsletterRegistrationImage == NEWSLETTER_PARTNER)}
	<div class="newsletterRegistrationInside__open__fermiere">
		<img class="newsletterRegistrationInside__open__fermiere__img" src="../assets/images/illustration_partner.png" alt="partenaire">
	</div>
	{:else}
	<div class="newsletterRegistrationInside__open__mailbox">
		<img class="newsletterRegistrationInside__open__mailbox__img" src="../assets/images/mailbox.png" alt="boite aux lettres">
	</div>
	{/if}
</div>
